import {useSuspenseQuery} from "@tanstack/react-query";
import {BreederService} from "../services/breeder-service";

export const useBreederInfo = () => useSuspenseQuery({
    queryKey: ['breeder', 'info'],
    queryFn: async () => await BreederService.info(),
});

